import ApplicationSerializer from "./application";
import DasherizedMixin from "./_dasherized-mixin";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class ProjectSerializer extends ApplicationSerializer.extend(DasherizedMixin) {
  @service abilities;

  usesProxy = true;

  primaryKey = "accountname";

  attrs = {
    lockedReason: "lockedreason",
    availableServices: "availableservices",
  };

  normalize(modelClass, resourceHash, prop) {
    resourceHash.links = {
      "api-keys": `${ENV.apiBaseUri}/apikey/list?projectkey=${resourceHash.accountname}`,
      archives: `${ENV.apiBaseUri}/archive/list?projectkey=${resourceHash.accountname}`,
      "archive-arguments": `${ENV.apiBaseUri}/archive/allowedarguments?projectkey=${resourceHash.accountname}`,
      "colocation-racks": `${ENV.apiBaseUri}/colocationrack/list?projectkey=${resourceHash.accountname}`,
      databases: `${ENV.apiBaseUri}/database/list?projectkey=${resourceHash.accountname}`,
      "dns-domains": `${ENV.apiBaseUri}/domain/list?projectkey=${resourceHash.accountname}`,
      "email-domains": `${ENV.apiBaseUri}/email/overview?projectkey=${resourceHash.accountname}`,
      "load-balancers": `${ENV.apiBaseUri}/loadbalancer/list?projectkey=${resourceHash.accountname}`,
      networks: `${ENV.apiBaseUri}/network/list?projectkey=${resourceHash.accountname}`,
      servers: `${ENV.apiBaseUri}/server/list?projectkey=${resourceHash.accountname}`,
      "file-storage-volumes": `${ENV.apiBaseUri}/filestorage/listvolumes?projectkey=${resourceHash.accountname}`,
      "block-storage-volumes": `${ENV.apiBaseUri}/blockstorage/list?projectkey=${resourceHash.accountname}`,
      "private-networks": `${ENV.apiBaseUri}/privatenetwork/list?projectkey=${resourceHash.accountname}`,
      "network-circuits": `${ENV.apiBaseUri}/networkcircuit/list?projectkey=${resourceHash.accountname}`,
      "platform-arguments": `${ENV.apiBaseUri}/server/allowedarguments?projectkey=${resourceHash.accountname}`,
      "server-templates": `${ENV.apiBaseUri}/server/templates?organizationnumber=${resourceHash.customernumber}&projectkey=${resourceHash.accountname}`,
      "reserved-ips": `${ENV.apiBaseUri}/ip/listown?projectkey=${resourceHash.accountname}`,
      "vpn-users": `${ENV.apiBaseUri}/vpn/listusers?projectkey=${resourceHash.accountname}`,
      shipments: `${ENV.apiBaseUri}/shipment/list?projectkey=${resourceHash.accountname}`,
      "remote-hands-request": `${ENV.apiBaseUri}/remotehands/list?projectkey=${resourceHash.accountname}`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }

  serialize() {
    let json = super.serialize(...arguments);

    json.organizationnumber = json.organization;
    json.projectkey = json.accountname;

    return json;
  }
}
